export default __webpack_public_path__ + "static/logo-19-418ed5d22b6df88f965a2ec7e7a62cd2.png";